import { useEffect, useState } from "react";
import { Loader2, Save, Send, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "../ui/switch";
import { api, apiError } from "../../lib/api";

const inputCls = "w-full rounded-lg bg-white/[0.04] border hairline px-3 py-2 text-sm text-white outline-none focus:border-[#4fc3f7]/60";

export const MetaCapiPanel = () => {
  const [cfg, setCfg] = useState(null);
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState("");
  const [result, setResult] = useState(null);

  const load = () => api.get("/admin/meta-capi").then((r) => setCfg(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);

  const save = async () => {
    setBusy("save");
    try {
      await api.put("/admin/meta-capi", { enabled: cfg.enabled, access_token: token, test_event_code: cfg.test_event_code || "" });
      setToken("");
      await load();
      toast.success("Conversions API salvata");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(""); }
  };
  const test = async () => {
    setBusy("test");
    try { const { data } = await api.post("/admin/meta-capi/test"); setResult(data); } catch (e) { toast.error(apiError(e)); } finally { setBusy(""); }
  };

  if (!cfg) return <Loader2 className="w-5 h-5 animate-spin text-slate-400" />;
  return (
    <div data-testid="meta-capi-panel" className="space-y-5">
      <p className="text-sm text-slate-400">Invia gli eventi a Meta anche dal server, oltre che dal Pixel nel browser. Ogni evento ha lo stesso ID nei due canali, così Meta lo conta una volta sola. Email e telefono del modulo vengono criptati (SHA-256) prima dell'invio. Il token resta salvato in modo cifrato sul server e non viene mai mostrato sul sito.</p>
      {!cfg.pixel_id && <p className="text-sm text-[#ffb07f]">Prima inserisci e salva l'ID Meta Pixel qui sopra, in "Tracking e conversioni".</p>}
      <label className="flex items-center gap-3 text-sm text-white"><Switch data-testid="capi-enabled" checked={cfg.enabled} onCheckedChange={(v) => setCfg((c) => ({ ...c, enabled: v }))} />Conversions API attiva</label>
      <label className="block">
        <span className="block text-xs text-slate-400 mb-1.5">Token di accesso (Events Manager → Impostazioni → Conversions API → Genera token)</span>
        <input data-testid="capi-token" type="password" autoComplete="off" className={inputCls} value={token} onChange={(e) => setToken(e.target.value)}
          placeholder={cfg.token_configured ? `Token salvato (…${cfg.token_hint}). Lascia vuoto per mantenerlo` : "Incolla qui il token"} />
      </label>
      <label className="block">
        <span className="block text-xs text-slate-400 mb-1.5">Codice evento di test (facoltativo, es. TEST12345, da togliere dopo le prove)</span>
        <input data-testid="capi-test-code" className={inputCls} value={cfg.test_event_code || ""} onChange={(e) => setCfg((c) => ({ ...c, test_event_code: e.target.value }))} />
      </label>
      <div className="flex flex-wrap gap-2">
        <button data-testid="capi-save" onClick={save} disabled={!!busy} className="h-10 px-5 rounded-full bg-[#ff5500] text-white text-sm font-medium inline-flex items-center gap-2">
          {busy === "save" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}Salva
        </button>
        <button data-testid="capi-test" onClick={test} disabled={!!busy} className="h-10 px-5 rounded-full border hairline text-white text-sm inline-flex items-center gap-2 hover:bg-white/5">
          {busy === "test" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}Invia evento di prova
        </button>
      </div>
      {result && (
        <p data-testid="capi-test-result" className={`text-sm flex items-center gap-2 ${result.sent ? "text-emerald-300" : "text-red-300"}`}>
          <ShieldCheck className="w-4 h-4" />
          {result.sent ? `Meta ha ricevuto l'evento (${result.events_received}). Controlla in Events Manager → Eventi di test.` : `Non inviato: ${result.reason === "not_configured" ? "attiva la API e inserisci token e ID Pixel" : result.reason}`}
        </p>
      )}
    </div>
  );
};
